import { apiClient } from '../../../lib/api/client';
import type {
  CommissionAgentPreview,
  CommissionItem,
  CommissionPreviewRequest,
  SaveCommissionsRequest,
  GetCommissionsParams,
  PagedResult,
} from '../types';

export async function getCommissionPreview(
  payload: CommissionPreviewRequest
): Promise<CommissionAgentPreview[]> {
  const response = await apiClient.post<CommissionAgentPreview[]>(
    '/commissions/preview',
    payload
  );
  return response.data;
}

export async function saveCommissions(
  payload: SaveCommissionsRequest
): Promise<number> {
  const response = await apiClient.post<number>('/commissions', payload);
  return response.data;
}

export async function getCommissions(
  params: GetCommissionsParams
): Promise<PagedResult<CommissionItem>> {
  const searchParams = new URLSearchParams();
  searchParams.set('dateFrom', params.dateFrom);
  searchParams.set('dateTo', params.dateTo);
  searchParams.set('pageNumber', String(params.pageNumber ?? 1));
  searchParams.set('pageSize', String(params.pageSize ?? 10));

  if (params.agentIds && params.agentIds.length > 0) {
    searchParams.set('agentIds', params.agentIds.join(','));
  }

  if (params.leadIds && params.leadIds.length > 0) {
    searchParams.set('leadIds', params.leadIds.join(','));
  }

  if (params.contactIds && params.contactIds.length > 0) {
    searchParams.set('contactIds', params.contactIds.join(','));
  }

  const response = await apiClient.get<PagedResult<CommissionItem>>(
    `/commissions?${searchParams.toString()}`
  );
  return response.data;
}
